import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        currentWordLookup: null,
    },
    mutations: {
        UPDATE_CURRENT_WORD_LOOKUP(state, word) {
            state.currentWordLookup = word
        }
    },
    actions: {
        updateCurrentWordLookup({commit}, word) {
            if (word !== this.state.currentWordLookup) {
                commit('UPDATE_CURRENT_WORD_LOOKUP', word)
            }
        }
    },
    getters: {
        currentWordLookup: state => state.currentWordLookup
    }
})
